<template>
  <div>
    <!-- <div class="state-select">
      <div class="select-box">
        <el-select
          :popper-append-to-body="false"
          v-model="selectState"
          class=""
        >
          <el-option
            v-for="(item, index) in selectStateOptions"
            :key="item.label + '_' + index"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <i class="icon-up-down"></i>
      </div>
    </div> -->
    <el-collapse v-model="activeNames" style="width: 100%">
      <controlWidthAndSizeAndZindex :options="options" :ids="ids" />
      <el-collapse-item @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '1')" title="下拉框" name="1">
        <div v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '1')">
          <slider-and-input
            class="mb16"
            inputWidth="small"
            inputHeight="small"
            :value.sync="opacity"
            title="透明度"
            :sliderMax="100"
            suffix="%"
          />
          <p class="mb8">文字样式</p>
          <text-setting-update
            :fontColor.sync="selectFontColor"
            :fontFamily.sync="selectFontFamily"
            :fontSize.sync="selectFontSize"
            :fontWeight.sync="selectFontWeight"
          />
          <border-radius
            class="mt16"
            :borderTypeFlag.sync="borderTypeFlag"
            :borderRadius.sync="borderRadius"
            :borderTopLeftRadius.sync="borderTopLeftRadius"
            :borderTopRightRadius.sync="borderTopRightRadius"
            :borderBottomRightRadius.sync="borderBottomRightRadius"
            :borderBottomLeftRadius.sync="borderBottomLeftRadius"
          />
          <div class="mt16">
            <span>边框</span>
            <cx-border
              :borderWidth.sync="selectBorderWidth"
              :borderStyle.sync="selectBorderStyle"
              :borderColor.sync="selectBorderColor"
              :borderIsThemeColor.sync="selectBorderIsThemeColor"
            />
          </div>
          <div class="mt16">
            <span>背景</span>
            <!-- <color-picker-theme-color
              class="flex1 mt8"
              :isThemeColor.sync="selectBgIsThemeColor"
              :color.sync="selectBgColor"
            /> -->
            <cx-color-picker
              class="custom-text-bg flex-box"
              :isThemeColor.sync="selectBgIsThemeColor"
              :colorArr.sync="selectBgColor"
            >
            </cx-color-picker>
          </div>
        </div>
      </el-collapse-item>

      <el-collapse-item
        @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '2')"
        title="下拉占位符"
        name="2"
      >
        <div v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '2')">
          <!--<cx-check-box :value.sync="showPlaceHolderText" class="font14">占位符内容</cx-check-box>-->
          <span class="font14">占位符内容</span>
          <div class="mt16">
            <el-input type="text" @input="e => (placeholderText = e)" :value="placeholderText"></el-input>
            <text-setting-update
              class="mt16"
              :fontColor.sync="placeHolderFontColor"
              :fontFamily.sync="placeHolderFontFamily"
              :fontSize.sync="placeHolderFontSize"
              :fontWeight.sync="placeHolderFontWeight"
            />
          </div>
        </div>
      </el-collapse-item>
      <el-collapse-item
        @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '3')"
        title="下拉列表项"
        name="3"
      >
        <div v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '3')">
          <el-checkbox v-if="request_prefix === 'bigScreen'" class="" v-model="hasSearch">支持搜索</el-checkbox>
          <div v-if="hasSearch && request_prefix === 'bigScreen'" class="encrypt-check mt8 mb16">
            <el-checkbox class="" v-model="encryptSearchQuery">支持加密搜索</el-checkbox>
            <el-tooltip class="item ml8" effect="dark" content="开启后，搜索参数会被转码" placement="top">
              <i class="icon-portal-info2"></i>
            </el-tooltip>
          </div>
          <el-checkbox class="" v-model="liIsSameSize">与下拉框宽高一致</el-checkbox>
          <slider-and-input
            class="mt16"
            v-if="!liIsSameSize"
            :value.sync="liWidth"
            title="列表宽度"
            :sliderMax="500"
            suffix="px"
          />
          <slider-and-input
            class="mt16"
            v-if="!liIsSameSize"
            :value.sync="liHeight"
            title="单行高度"
            :sliderMax="200"
            suffix="px"
          />
          <div class="mt16">
            <span>边框</span>
            <cx-border
              :borderWidth.sync="liBorderWidth"
              :borderStyle.sync="liBorderStyle"
              :borderColor.sync="liBorderColor"
              :borderIsThemeColor.sync="liBorderIsThemeColor"
            />
          </div>
          <border-radius
            class="mt16"
            :borderTypeFlag.sync="liBorderTypeFlag"
            :borderRadius.sync="liBorderRadius"
            :borderTopLeftRadius.sync="liBorderTopLeftRadius"
            :borderTopRightRadius.sync="liBorderTopRightRadius"
            :borderBottomRightRadius.sync="liBorderBottomRightRadius"
            :borderBottomLeftRadius.sync="liBorderBottomLeftRadius"
          />
          <div class="mt16">
            <span class="mb8 inlineMiddle">文字样式</span>
            <text-setting-update
              :fontColor.sync="liFontColor"
              :fontFamily.sync="liFontFamily"
              :fontSize.sync="liFontSize"
              :fontWeight.sync="liFontWeight"
            />
          </div>
          <!-- <color-picker class="mt16" :color.sync="primaryLiBg" titlePosition="singleLine" title="默认背景" />
          <color-picker class="mt16" :color.sync="selectLiBg" titlePosition="singleLine" title="选中背景" />
          <color-picker class="mt16" :color.sync="hoverLiBg" titlePosition="singleLine" title="悬浮背景" />
          <color-picker class="mt16" :color.sync="liFontColor" titlePosition="singleLine" title="默认字体颜色" />
          <color-picker class="mt16" :color.sync="selectLiColor" titlePosition="singleLine" title="选中字体颜色" />
          <color-picker class="mt16" :color.sync="hoverLiColor" titlePosition="singleLine" title="悬浮字体颜色" /> -->
          <div class="mt16">
            <p class="fs14">默认背景</p>
            <cx-color-picker
              class="mt12"
              :isThemeColor.sync="liBgIsThemeColor"
              :colorArr.sync="primaryLiBg"
            ></cx-color-picker>
          </div>
          <div class="mt16">
            <p class="fs14">选中背景</p>
            <cx-color-picker
              class="mt12"
              :isThemeColor.sync="liBgSltIsThemeColor"
              :colorArr.sync="selectLiBg"
            ></cx-color-picker>
          </div>
          <div class="mt16">
            <p class="fs14">悬浮背景</p>
            <cx-color-picker
              class="mt12"
              :isThemeColor.sync="liBgHovIsThemeColor"
              :colorArr.sync="hoverLiBg"
            ></cx-color-picker>
          </div>
          <!-- <div class="mt16">
            <p class="fs14">默认字体颜色</p>
            <cx-color-picker class="mt12" :isThemeColor.sync="liTextIsThemeColor" :colorArr.sync="liFontColor"></cx-color-picker>
          </div> -->
          <div class="mt16">
            <p class="fs14">选中字体颜色</p>
            <cx-color-picker
              class="mt12"
              :isThemeColor.sync="liSltTextIsThemeColor"
              :colorArr.sync="selectLiColor"
            ></cx-color-picker>
          </div>
          <div class="mt16">
            <p class="fs14">悬浮字体颜色</p>
            <cx-color-picker
              class="mt12"
              :isThemeColor.sync="liHovTextIsThemeColor"
              :colorArr.sync="hoverLiColor"
            ></cx-color-picker>
          </div>
          <div class="content-item mt16">
            <div class="checkbox_colorPicker_container">
              <span>阴影</span>
              <span class="icon-portal-plus theme-color right-icon" @click="addBoxshadow"></span>
            </div>
            <box-shadow
              :boxShadowH.sync="boxShadowH"
              :boxShadowV.sync="boxShadowV"
              :boxShadowBlur.sync="boxShadowBlur"
              :boxShadowSpread.sync="boxShadowSpread"
              :boxShadowColor.sync="boxShadowColor"
            ></box-shadow>
          </div>
        </div>
      </el-collapse-item>
      <el-collapse-item
        v-show="$store.state.states.showPluginSetting"
        @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '5')"
        title="插件"
        name="5"
      >
        <div class="setting-item">
          <elementPluginSetting :pluginName="pluginName" :myid="ids"></elementPluginSetting>
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
import controlWidthAndSizeAndZindex from "publicSetting/controlWidthAndSizeAndZindex.vue"
import elementPluginSetting from "publicSetting/elementPluginSetting.vue"
import { withMethodsHistoryCombine } from "utils/revork"
export default withMethodsHistoryCombine({
  components: {
    controlWidthAndSizeAndZindex,
    elementPluginSetting
  },
  props: {
    options: Object
  },
  data() {
    return {
      activeNames: ["0", "1", "2", "3"],
      collapseActiveNames: ["0", "1", "2", "3"],
      allCollapseNames: ["3"],
      this1: this,
      selectState: "1",
      selectStateOptions: [
        {
          value: "1",
          label: "默认状态"
        },
        {
          value: "2",
          label: "悬浮状态"
        },
        {
          value: "3",
          label: "选中状态"
        }
      ]
    }
  },
  methods: {
    resetSelectBorder(val) {
      this.liBorderRadius = val
      this.liBorderTopLeftRadius = val
      this.liBorderTopRightRadius = val
      this.liBorderBottomRightRadius = val
      this.liBorderBottomLeftRadius = val
    },
    changeBorderRadiusType(value, hoverFlag) {
      let propName = hoverFlag ? hoverFlag + "BorderTypeFlag" : "borderTypeFlag"
      if (this[propName] === value) {
        return
      }
      this[propName] = value
      // 暂时只处理默认情况  悬浮情况后面有可能会有改动
      this.borderTopRightRadius = this.borderTopLeftRadius
      this.borderBottomLeftRadius = this.borderTopLeftRadius
      this.borderBottomRightRadius = this.borderTopLeftRadius
    },
    changeSelectBorderRadiusType(value, hoverFlag) {
      let propName = hoverFlag ? hoverFlag + "liBorderTypeFlag" : "liBorderTypeFlag"
      if (this[propName] === value) {
        return
      }
      this[propName] = value
      // 暂时只处理默认情况  悬浮情况后面有可能会有改动
      this.liBorderTopRightRadius = this.liBorderTopLeftRadius
      this.liBorderBottomLeftRadius = this.liBorderTopLeftRadius
      this.liBorderBottomRightRadius = this.liBorderTopLeftRadius
    },
    addBoxshadow() {
      if (!Array.isArray(this.boxShadowH)) {
        this.boxShadowH = [this.boxShadowH]
        this.boxShadowV = [this.boxShadowV]
        this.boxShadowBlur = [this.boxShadowBlur]
        this.boxShadowSpread = [this.boxShadowSpread]
        this.boxShadowColor = [this.boxShadowColor]
      }
      let boxShadowH = JSON.parse(JSON.stringify(this.boxShadowH))
      let boxShadowV = JSON.parse(JSON.stringify(this.boxShadowV))
      let boxShadowBlur = JSON.parse(JSON.stringify(this.boxShadowBlur))
      let boxShadowSpread = JSON.parse(JSON.stringify(this.boxShadowSpread))
      let boxShadowColor = JSON.parse(JSON.stringify(this.boxShadowColor))
      boxShadowH.push(0)
      boxShadowV.push(4)
      boxShadowBlur.push(4)
      boxShadowSpread.push(0)
      boxShadowColor.push("rgba(0,0,0,0.25)")
      this.boxShadowH = boxShadowH
      this.boxShadowV = boxShadowV
      this.boxShadowBlur = boxShadowBlur
      this.boxShadowSpread = boxShadowSpread
      this.boxShadowColor = boxShadowColor
    }
  },
  computed: {
    ids() {
      return this.$store.state.states.activeID
    },
    opacity: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "opacity", "opacity", 100)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "opacity", false)
      }
    },
    pluginName: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "pluginName", "pluginName", [])
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "pluginName", false)
      }
    },
    hasSearch: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "hasSearch", "hasSearch", false)
      },
      set(val) {
        this.$changeOptionsEV(val, "hasSearch", false)
      }
    },
    liIsSameSize: {
      get() {
        return this.options.liIsSameSize
      },
      set(val) {
        this.$changeOptionsEV(val, "liIsSameSize", false)
      }
    },
    liWidth: {
      get() {
        return this.options.liWidth
      },
      set(val) {
        this.$changeOptionsEV(val, "liWidth", false)
      }
    },
    liHeight: {
      get() {
        return this.options.liHeight
      },
      set(val) {
        this.$changeOptionsEV(val, "liHeight", false)
      }
    },
    placeholderText: {
      get() {
        return this.options.placeholderText
      },
      set(val) {
        this.$changeOptionsEV(val, "placeholderText", false)
      }
    },
    primaryLiBg: {
      get() {
        return this.options.primaryLiBg
      },
      set(val) {
        this.$changeOptionsEV(val, "primaryLiBg", false)
      }
    },
    selectLiBg: {
      get() {
        return this.options.selectLiBg
      },
      set(val) {
        this.$changeOptionsEV(val, "selectLiBg", false)
      }
    },
    hoverLiBg: {
      get() {
        return this.options.hoverLiBg
      },
      set(val) {
        this.$changeOptionsEV(val, "hoverLiBg", false)
      }
    },
    selectLiColor: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "selectLiColor", "selectLiColor", "rgba('0,0,0,1')")
      },
      set(val) {
        this.$changeOptionsEV(val, "selectLiColor", false)
      }
    },
    hoverLiColor: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "hoverLiColor", "hoverLiColor", "rgba(0, 0, 0, 0.8)")
      },
      set(val) {
        this.$changeOptionsEV(val, "hoverLiColor", false)
      }
    },
    selectFontFamily: {
      get() {
        return this.options.selectFontFamily
      },
      set(val) {
        this.$changeOptionsEV(val, "selectFontFamily", false)
      }
    },
    selectFontSize: {
      get() {
        return this.options.selectFontSize
      },
      set(val) {
        this.$changeOptionsEV(val, "selectFontSize", false)
      }
    },
    selectFontWeight: {
      get() {
        return this.options.selectFontWeight
      },
      set(val) {
        this.$changeOptionsEV(val, "selectFontWeight", false)
      }
    },
    selectFontColor: {
      get() {
        return this.options.selectFontColor
      },
      set(val) {
        this.$changeOptionsEV(val, "selectFontColor", false)
      }
    },
    selectBgColor: {
      get() {
        return this.options.selectBgColor
      },
      set(val) {
        this.$changeOptionsEV(val, "selectBgColor", false)
      }
    },
    selectBgIsThemeColor: {
      get() {
        return this.options.selectBgIsThemeColor
      },
      set(val) {
        this.$changeOptionsEV(val, "selectBgIsThemeColor", false)
      }
    },
    placeHolderFontFamily: {
      get() {
        return this.options.placeHolderFontFamily
      },
      set(val) {
        this.$changeOptionsEV(val, "placeHolderFontFamily", false)
      }
    },
    placeHolderFontSize: {
      get() {
        return this.options.placeHolderFontSize
      },
      set(val) {
        this.$changeOptionsEV(val, "placeHolderFontSize", false)
      }
    },
    placeHolderFontWeight: {
      get() {
        return this.options.placeHolderFontWeight
      },
      set(val) {
        this.$changeOptionsEV(val, "placeHolderFontWeight", false)
      }
    },
    placeHolderFontColor: {
      get() {
        return this.options.placeHolderFontColor
      },
      set(val) {
        this.$changeOptionsEV(val, "placeHolderFontColor", false)
      }
    },
    selectBorderColor: {
      get() {
        return this.options.selectBorderColor
      },
      set(val) {
        this.$changeOptionsEV(val, "selectBorderColor", false)
      }
    },
    selectBorderWidth: {
      get() {
        return this.options.selectBorderWidth
      },
      set(val) {
        this.$changeOptionsEV(val, "selectBorderWidth", false)
      }
    },
    selectBorderStyle: {
      get() {
        return this.options.selectBorderStyle
      },
      set(val) {
        this.$changeOptionsEV(val, "selectBorderStyle", false)
      }
    },
    selectBorderIsThemeColor: {
      get() {
        return this.options.selectBorderIsThemeColor
      },
      set(val) {
        this.$changeOptionsEV(val, "selectBorderIsThemeColor", false)
      }
    },
    liBorderColor: {
      get() {
        return this.options.liBorderColor
      },
      set(val) {
        this.$changeOptionsEV(val, "liBorderColor", false)
      }
    },
    liBorderWidth: {
      get() {
        return this.options.liBorderWidth
      },
      set(val) {
        this.$changeOptionsEV(val, "liBorderWidth", false)
      }
    },
    liBorderStyle: {
      get() {
        return this.options.liBorderStyle
      },
      set(val) {
        this.$changeOptionsEV(val, "liBorderStyle", false)
      }
    },
    liBorderIsThemeColor: {
      get() {
        return this.options.liBorderIsThemeColor
      },
      set(val) {
        this.$changeOptionsEV(val, "liBorderIsThemeColor", false)
      }
    },
    borderTypeFlag: {
      get() {
        let defaultType = 1
        if (!this.options.hasOwnProperty("borderTypeFlag")) {
          if (
            ((this.borderTopLeftRadius === this.borderTopRightRadius) === this.borderBottomLeftRadius) ===
            this.borderBottomRightRadius
          ) {
            defaultType = 2
          }
        }
        // return this.checkAndSetPrimaryVal(this.options, "borderTypeFlag", "borderTypeFlag", defaultType)
        // 上面方法貌似是执行需要一定的时间，造成最开始还未写入值，进行点击 会出现问题
        return this.options.borderTypeFlag || defaultType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderTypeFlag", false)
      }
    },
    borderRadius: {
      get() {
        return Number(this.options.borderBottomLeftRadius)
      },
      set(newVal) {
        this.$changeOptionsEV(
          [newVal, newVal, newVal, newVal],
          ["borderTopLeftRadius", "borderTopRightRadius", "borderBottomRightRadius", "borderBottomLeftRadius"],
          false
        )
      }
    },
    borderTopLeftRadius: {
      get() {
        return Number(this.options.borderTopLeftRadius)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderTopLeftRadius", false)
      }
    },
    borderTopRightRadius: {
      get() {
        return Number(this.options.borderTopRightRadius)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderTopRightRadius", false)
      }
    },
    borderBottomRightRadius: {
      get() {
        return Number(this.options.borderBottomRightRadius)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderBottomRightRadius", false)
      }
    },
    borderBottomLeftRadius: {
      get() {
        return Number(this.options.borderBottomLeftRadius)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderBottomLeftRadius", false)
      }
    },
    liBorderTypeFlag: {
      get() {
        let defaultType = 1
        if (!this.options.hasOwnProperty("liBorderTypeFlag")) {
          if (
            ((this.liBorderTopLeftRadius === this.liBorderTopRightRadius) === this.liBorderBottomLeftRadius) ===
            this.liBorderBottomRightRadius
          ) {
            defaultType = 2
          }
        }
        // return this.checkAndSetPrimaryVal(this.options, "borderTypeFlag", "borderTypeFlag", defaultType)
        // 上面方法貌似是执行需要一定的时间，造成最开始还未写入值，进行点击 会出现问题
        return this.options.liBorderTypeFlag || defaultType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liBorderTypeFlag", false)
      }
    },
    liBorderRadius: {
      get() {
        return Number(this.options.liBorderBottomLeftRadius)
      },
      set(newVal) {
        this.$changeOptionsEV(
          [newVal, newVal, newVal, newVal],
          ["liBorderTopLeftRadius", "liBorderTopRightRadius", "liBorderBottomRightRadius", "liBorderBottomLeftRadius"],
          false
        )
      }
    },
    liBorderTopLeftRadius: {
      get() {
        return Number(this.options.liBorderTopLeftRadius)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liBorderTopLeftRadius", false)
      }
    },
    liBorderTopRightRadius: {
      get() {
        return Number(this.options.liBorderTopRightRadius)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liBorderTopRightRadius", false)
      }
    },
    liBorderBottomRightRadius: {
      get() {
        return Number(this.options.liBorderBottomRightRadius)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liBorderBottomRightRadius", false)
      }
    },
    liBorderBottomLeftRadius: {
      get() {
        return Number(this.options.liBorderBottomLeftRadius)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liBorderBottomLeftRadius", false)
      }
    },
    liFontFamily: {
      get() {
        return this.options.liFontFamily
      },
      set(val) {
        this.$changeOptionsEV(val, "liFontFamily", false)
      }
    },
    liFontSize: {
      get() {
        return this.options.liFontSize
      },
      set(val) {
        this.$changeOptionsEV(val, "liFontSize", false)
      }
    },
    liFontWeight: {
      get() {
        return this.options.liFontWeight
      },
      set(val) {
        this.$changeOptionsEV(val, "liFontWeight", false)
      }
    },
    liFontColor: {
      get() {
        return this.options.liFontColor
      },
      set(val) {
        this.$changeOptionsEV(val, "liFontColor", false)
      }
    },
    boxShadowColor: {
      get() {
        return this.options.boxShadowColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowColor", false)
      }
    },
    boxShadowH: {
      get() {
        return this.options.boxShadowH
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowH", false)
      }
    },
    boxShadowV: {
      get() {
        return this.options.boxShadowV
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowV", false)
      }
    },
    boxShadowBlur: {
      get() {
        return this.options.boxShadowBlur
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowBlur", false)
      }
    },
    boxShadowSpread: {
      get() {
        return this.options.boxShadowSpread
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowSpread", false)
      }
    },
    liBgIsThemeColor: {
      get() {
        return this.options.liBgIsThemeColor || false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liBgIsThemeColor", false)
      }
    },
    liBgSltIsThemeColor: {
      get() {
        return this.options.liBgSltIsThemeColor || false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liBgSltIsThemeColor", false)
      }
    },
    liBgHovIsThemeColor: {
      get() {
        return this.options.liBgHovIsThemeColor || false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liBgHovIsThemeColor", false)
      }
    },
    liTextIsThemeColor: {
      get() {
        return this.options.liTextIsThemeColor || false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liTextIsThemeColor", false)
      }
    },
    liSltTextIsThemeColor: {
      get() {
        return this.options.liSltTextIsThemeColor || false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liSltTextIsThemeColor", false)
      }
    },
    liHovTextIsThemeColor: {
      get() {
        return this.options.liHovTextIsThemeColor || false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liHovTextIsThemeColor", false)
      }
    },
    isAdmin() {
      return this.$store.state.states.managerType === 1 ? true : false
    },
    encryptSearchQuery: {
      get() {
        return this.options.encryptSearchQuery || false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "encryptSearchQuery", false)
      }
    }
  },
  mounted() {
    this.$collapseControl({
      activeNames: this.activeNames,
      collapseActiveNames: this.collapseActiveNames,
      allCollapseNames: this.allCollapseNames
    })
  }
})
</script>

<style lang="scss">
.state-select {
  width: 100%;
  height: 45px;
  // margin-bottom: 20px;
  padding: 8px 16px;
  box-sizing: border-box;
  border-bottom: 1px solid var(--elCollapseItemHeaderBgColor);
  .select-box {
    position: relative;
    width: 88px;
    .el-input__inner {
      background: transparent;
      height: 28px;
      line-height: 28px;
      font-weight: 600;
      font-size: 14px;
      padding-left: 8px;
      &:hover {
        background: var(--elCollapseItemHeaderBgColor);
      }
    }
    .el-icon-arrow-up {
      display: none;
    }
    .icon-up-down {
      position: absolute;
      font-size: 12px;
      right: 8px;
      top: 8px;
      color: var(--thirdTextColor);
      cursor: pointer;
    }
  }
  .el-select-dropdown__list {
    width: 120px;
  }
}
.encrypt-check {
  padding: 12px;
  background-color: rgba(44, 47, 51, 1);
}
</style>
